export default __webpack_public_path__ + "static/media/header_four.b491c5b3.jpg";